import "./RemodelingCostGuide.module.css";
import Header from "@/reusable_sections/Header";
import CostFactorsIntro from "./sections/CostFactorsIntro";
import ServiceCostFactors from "./sections/ServiceCostFactors";
import ServicesOverview from "./sections/ServicesOverview";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import Footer from "@/reusable_sections/Footer";
export default function RemodelingCostGuidePage() {
  return <div>
      <Header />
      <CostFactorsIntro />
      <ServiceCostFactors />
      <ServicesOverview />
      <EstimateRequestForm />
      <Footer />
    </div>;
}